import { render, staticRenderFns } from "./SandboxLogoutDialog.vue?vue&type=template&id=3f47cfb8&scoped=true"
import script from "./SandboxLogoutDialog.vue?vue&type=script&lang=ts"
export * from "./SandboxLogoutDialog.vue?vue&type=script&lang=ts"
import style0 from "./SandboxLogoutDialog.vue?vue&type=style&index=0&id=3f47cfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47cfb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VSpacer})
